<template>
  <div class="introduce">
    <v-row class="mx-0 my-5">
      <v-col style="text-align:center">
        <span class="ct-text-subtitle sectTitle2">{{ title }}</span>
      </v-col>
    </v-row>
    <progressBar ref="progressBar" :step="curStep" @getCurStep="getCurStep" />
    <v-container class="content-detail">
      <v-row v-if="item.content && show" data-aos="fade-up">
        <v-col cols="12" md="6" lg="5" class="pt-16 text-center">
          <img
            :src="item.content.imageUrl"
            :alt="item.content.title"
            :title="item.content.title"
            class="pt-16 mt-16 pt-md-0 mt-md-0"
          />
        </v-col>
        <v-col cols="12" md="6" lg="7" class="py-md-16 px-10">
          <div class="font-weight-bold py-5 item-title">
            {{ item.content.title }}
          </div>
          <p class="item-description">{{ item.content.description }}</p>
          <div class="text-center my-10">
            <v-btn
              v-if="item.step === 5"
              :color="'#FFF777'"
              title="馬上試試"
              class="ct-text-bolder"
              @click="$emit('moveToCalculator')"
            >
              <span style="display:inline-block">馬上試試</span>
              <img
                :src="iconArrowSrc"
                alt="馬上試試"
                title="馬上試試"
                class="ml-1"
              />
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-row justify="center" class="mx-0">
      <v-col md="1" sm="2" class="pa-2 pa-md-6">
        <div
          role="button"
          tabindex="0"
          class="arrow"
          title="往前一步驟"
          @click="setStep(curStep - 1)"
          @keypress="setStep(curStep - 1)"
        >
          &emsp;
        </div>
      </v-col>
      <v-col md="1" sm="2" class="pa-2 pa-md-6">
        <div
          role="button"
          tabindex="0"
          class="arrow right"
          title="往後一步驟"
          @click="setStep(curStep + 1)"
          @keypress="setStep(curStep + 1)"
        >
          &emsp;
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import progressBar from "@/components/carbon/progressBar.vue";
export default {
  props: {
    title: {
      type: String
    }
  },
  data() {
    return {
      curStep: 1,
      item: {},
      show: false,
      iconArrowSrc: require("@/assets/images/carbon/icon_arror.svg"),
      stepContents: [
        {
          step: 1,
          content: {
            imageUrl: require("@/assets/images/carbon/step-1.png"),
            title: "樹木與二氧化碳",
            description:
              "人類的活動排放大量的溫室氣體到空氣中，二氧化碳便是主要的溫室氣體之一。隨著這些溫室氣體的逐年增加，讓地球上的氣溫一年比一年高，極端氣候更是越來越常見。那該怎麼辦呢？除了透過活動的改變減少溫室氣體的排放外，我們還能夠透過樹木來吸收這些空氣中的二氧化碳呢！自然界的樹木，其實是地球減碳的重要幫手喔！一起來認識樹木是如何做到的吧！"
          }
        },
        {
          step: 2,
          content: {
            imageUrl: require("@/assets/images/carbon/step-2.png"),
            title: "從光合作用到減碳的作用",
            description:
              "綠色植物都擁有一種叫「葉綠體」的構造，葉綠體負責一個重要的工作，那就是「光合作用」。光合作用會幫助植物吸收太陽的光線，並將水還有空氣中的二氧化碳，製作成植物需要的能量，同時還會排放出動物呼吸時所需要的氧氣到空氣中。樹木的葉子就是葉綠體最多的地方，葉子在光合作用時吸收二氧化碳，製作成能量以後，會轉變成樹木長大的原料，所以樹木其實是一邊固定二氧化碳一邊長大呢！"
          }
        },
        {
          step: 3,
          content: {
            imageUrl: require("@/assets/images/carbon/step-3.png"),
            title: "樹木集成了森林，森林是二氧化碳的倉庫",
            description:
              "許多樹木聚集的地方我們稱之為「森林」，森林裡除了樹木外，地面上的落葉、樹枝還有地面下的土壤，也都儲存了大量由二氧化碳所轉換來的碳。大家口中常說的「碳匯」，指的就是儲存二氧化碳的倉庫，所以當我們提到一整個森林固定了多少二氧化碳時，便會稱之為「森林碳匯」。"
          }
        },
        {
          step: 4,
          content: {
            imageUrl: require("@/assets/images/carbon/step-4.png"),
            title: "校園裡的樹木正在幫忙減碳喔！",
            description:
              "那麼都市中有沒有碳匯呢？每天活動的校園裡，是不是種了許多樹木呢？這些樹木讓學校成為都市中的小森林，其實也儲存了許多碳喔！隨著這些校園中的樹木越長越高，越長越大，其實他們都默默地將二氧化碳固定在身體裡了呢！"
          }
        },
        {
          step: 5,
          content: {
            imageUrl: require("@/assets/images/carbon/step-5.png"),
            title: "儲存的碳是可以計算出來的嗎？",
            description:
              "那麼我們可以計算出樹木到底總共儲存了多少碳嗎？這時候就要幫樹木來測量身高及腰圍了！我們透過量測樹木的高矮胖瘦，推估他們到底有多重，這些重量再透過科學家們的研究成果，就可以轉換為碳的數量了！我們甚至可以根據樹木的生長速度，去推測一棵樹木未來的碳匯會是多少呢，很神奇吧！"
          }
        }
      ]
    };
  },
  components: {
    progressBar
  },
  mounted() {
    this.getCurStep(this.curStep);
  },
  methods: {
    getCurStep(step) {
      this.show = false;
      this.curStep = step;
      this.item = this.stepContents.find(e => e.step === step);
      setTimeout(() => {
        this.show = true;
      }, 100);
    },
    setStep(step) {
      if (step > 0 && step <= this.stepContents.length) {
        this.$refs.progressBar.setStep(step);
        this.curStep = step;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.introduce {
  height: auto;
  margin-bottom: 5rem;
  position: relative;
  overflow: hidden;
}

.content-detail {
  height: auto;
  min-height: 55vh;

  @media all and (max-width: 768px) {
    min-height: 85vh;
  }

  @media all and (max-width: 600px) {
    img {
      width: 70%;
    }
  }

  .item-title {
    color: #2f4b3b;
    line-height: 1;
    padding: 1rem 0;
    font-size: 1.75rem;
    font-weight: 700;

    @media all and (max-width: 768px) {
      font-size: 1.125rem;
    }
  }

  .item-description {
    text-align: justify;
    color: #111;
    line-height: 1.875rem;
  }
}

.arrow {
  width: 80px;
  height: 80px;

  @media all and (max-width: 768px) {
    width: 60px;
    height: 60px;
  }
}
</style>
